import { useState, useEffect } from 'react';

/**
 * Responsive breakpoints
 * mobile: < 768px
 * tablet: 768px - 1024px
 * desktop: > 1024px
 */
const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
};

/**
 * Hook to detect screen size and provide responsive utilities
 */
export default function useResponsive() {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < BREAKPOINTS.mobile;
  const isTablet = windowWidth >= BREAKPOINTS.mobile && windowWidth < BREAKPOINTS.tablet;
  const isDesktop = windowWidth >= BREAKPOINTS.tablet;

  // For showing sidebar vs bottom nav
  const showSidebar = windowWidth >= BREAKPOINTS.mobile;
  const showBottomNav = windowWidth < BREAKPOINTS.mobile;

  // Dynamic grid columns based on width
  const getGridColumns = (minItemWidth = 160) => {
    const padding = 48; // Left + right padding
    const availableWidth = windowWidth - padding;
    return Math.max(2, Math.floor(availableWidth / minItemWidth));
  };

  return {
    windowWidth,
    isMobile,
    isTablet,
    isDesktop,
    showSidebar,
    showBottomNav,
    getGridColumns,
    breakpoints: BREAKPOINTS,
  };
}
